module.exports = __webpack_public_path__ + "static/character-modal-background-6d3912e2be2c07a46ccd00f1ba67620a.svg";